import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Radio,
  Dropdown,
  Button,
  Input
} from 'semantic-ui-react'

const CardOrderSetTemplateUX = (props: any) => {
    return(
      <div
        className="ui form"
        id="CardOrderSetTemplateUX-div-0"
        style={{display: "flex", width: "100%", height: "95vh"}}>
        <div
          className="size small --override-disabled --grey"
          id="CardOrderSetTemplateUX-div-37"
          style={{ width: "30%", padding: "15px", borderRight: "2px solid rgb(204, 204, 204)" }}>
          
          <div
            id="CardOrderSetTemplateUX-div-40"
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px", }}>
            
            <label
              id="CardOrderSetTemplateUX-label-44"
              style={{ fontWeight: "bold", fontSize: "18px" }}>
              {props.languageUX === "en" ? "List of command sets" : "รายการชุดคำสั่ง"}
            </label>
            <div
              id="CardOrderSetTemplateUX-div-140">
              {props.addNewOrder}
            </div>
          </div>
          <Form
            id="CardOrderSetTemplateUX-Form-117">
            <FormGroup
              id="CardOrderSetTemplateUX-FormGroup-118"
              inline={true}
              style={{ paddingTop: "15px" }}>
              <FormField
                id="CardOrderSetTemplateUX-FormField-119"
                inline={true}
                width={10}>
                <div
                  id="CardOrderSetTemplateUX-div-122"
                  style={{ width: "100%" }}>
                  
                  <div
                    id="CardOrderSetTemplateUX-div-125">
                    {props.languageUX === "en" ? "Find a set of instructions" : "ค้นหาชุดคำสั่ง"}
                  </div>
                  <Input
                    id="CardOrderSetTemplateUX-Input-172"
                    name="name"
                    onChange={props.onChangeSearchData}
                    value={props.searchTemplate?.name}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-120"
                inline={true}
                width={8}>
                <div
                  id="CardOrderSetTemplateUX-div-121"
                  style={{ width: "100%" }}>
                  
                  <div
                    id="CardOrderSetTemplateUX-div-123">
                    {props.languageUX === "en" ? "Instruction set type" : "ประเภทชุดคำสั่ง"}
                  </div>
                  <Dropdown
                    fluid={true}
                    id="CardOrderSetTemplateUX-Dropdown-127"
                    name="type"
                    onChange={props.onChangeSearchData}
                    options={props.typeOrderOption}
                    selection={true}
                    value={props.searchTemplate?.type}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardOrderSetTemplateUX-FormGroup-146"
              inline={true}>
              <FormField
                id="CardOrderSetTemplateUX-FormField-147"
                inline={true}
                width={8}>
                <div
                  id="CardOrderSetTemplateUX-div-149"
                  style={{ width: "100%" }}>
                  
                  <div
                    id="CardOrderSetTemplateUX-div-150">
                    {props.languageUX === "en" ? "department" : "แผนก"}
                  </div>
                  <Dropdown
                    clearable={true}
                    disabled={props.searchTemplate?.type == "P"}
                    fluid={true}
                    id="CardOrderSetTemplateUX-Dropdown-153"
                    name="division"
                    onChange={props.onChangeSearchData}
                    options={props.templateDivisionOption}
                    search={true}
                    selection={true}
                    value={props.searchTemplate?.division}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-148"
                inline={true}
                width={7}>
                <div
                  id="CardOrderSetTemplateUX-div-151"
                  style={{ width: "100%" }}>
                  
                  <div
                    id="CardOrderSetTemplateUX-div-152">
                    {props.languageUX === "en" ? "physician" : "แพทย์"}
                  </div>
                  <div
                    id="CardOrderSetTemplateUX-div-169"
                    style={{ width: "100%" }}>
                    {props.searchDoctorTemplate}
                  </div>
                </div>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-155"
                inline={true}
                width={3}>
                <div
                  id="CardOrderSetTemplateUX-div-156"
                  style={{ width: "100%", marginTop: "18px" }}>
                  
                  <div
                    id="CardOrderSetTemplateUX-div-171">
                    {props.buttonSearchTemplate}
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <div
            id="CardOrderSetTemplateUX-div-53"
            style={{ paddingTop: "15px" }}>
            
            <div
              id="CardOrderSetTemplateUX-div-141">
              {props.templateList}
            </div>
          </div>
        </div>
        <div
          className="size small --override-disabled --grey"
          id="CardOrderSetTemplateUX-div-38"
          style={{flex: "3 1 0%", height: "95vh", overflow: "auto", padding: "15px", marginTop: "60px" }}>
          
          <Form
            id="CardOrderSetTemplateUX-Form-87">
            <FormGroup
              id="CardOrderSetTemplateUX-FormGroup-88"
              inline={true}
              style={{ ...(!props.showTemplateDetail && { display: "none"}) }}>
              <FormField
                id="CardOrderSetTemplateUX-FormField-89"
                inline={true}
                width="12">
                <div
                  id="CardOrderSetTemplateUX-div-90"
                  style={{ display: "flex", width: "100%", alignItems: "center" }}>
                  
                  <div
                    id="CardOrderSetTemplateUX-div-163"
                    style={{ display: "flex", width: "200px" }}>
                    
                    <label
                      id="CardOrderSetTemplateUX-label-167"
                      style={{ fontWeight: "bold" }}>
                      {props.languageUX === "en" ? "Command set name" : "ชื่อชุดคำสั่ง"}
                    </label>
                    <div
                      id="CardOrderSetTemplateUX-div-165"
                      style={{ color: "red", margin: "0px 5px" }}>
                      *
                    </div>
                    <div
                      id="CardOrderSetTemplateUX-div-166">
                      :
                    </div>
                  </div>
                  <div
                    id="CardOrderSetTemplateUX-div-164"
                    style={{ width: "100%" }}>
                    
                    <Input
                      fluid={true}
                      id="CardOrderSetTemplateUX-Input-168"
                      name="name"
                      onChange={props.onChangeData}
                      value={props.orderDetail?.name || ""}>
                    </Input>
                  </div>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardOrderSetTemplateUX-FormGroup-97"
              inline={true}
              style={{ ...(!props.showTemplateDetail && { display: "none"}) }}>
              <FormField
                id="CardOrderSetTemplateUX-FormField-98"
                inline={true}
                width={2}>
                <label
                  id="CardOrderSetTemplateUX-label-109"
                  style={{ fontWeight: "bold" }}>
                  ประเภทชุดคำสั่ง : 
                </label>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-99"
                inline={true}>
                <Radio
                  checked={props.orderDetail?.type === "G"}
                  id="CardOrderSetTemplateUX-Radio-110"
                  label={props.languageUX === "en" ? "Central command set" : "ชุดคำสั่งกลาง"}
                  name="type"
                  onChange={props.onChangeData}
                  value="G">
                </Radio>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-100"
                inline={true}>
                <Radio
                  checked={props.orderDetail?.type === "D"}
                  id="CardOrderSetTemplateUX-Radio-111"
                  label={props.languageUX === "en" ? "Departmental Orders" : "ชุดคำสั่งประจำแผนก"}
                  name="type"
                  onChange={props.onChangeData}
                  value="D">
                </Radio>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-101"
                inline={true}
                width={3}>
                <div
                  id="CardOrderSetTemplateUX-div-128"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    disabled={props.orderDetail?.type !== "D"}
                    fluid={true}
                    id="CardOrderSetTemplateUX-Dropdown-129"
                    name="division"
                    onChange={props.onChangeData}
                    options={props.orderDivisionOption}
                    placeholder="เลือกแผนก"
                    search={true}
                    selection={true}
                    value={props.orderDetail?.division}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-102"
                inline={true}>
                <Radio
                  checked={props.orderDetail?.type === "P"}
                  id="CardOrderSetTemplateUX-Radio-114"
                  label={props.languageUX === "en" ? "Medical order set" : "ชุดคำสั่งแพทย์"}
                  name="type"
                  onChange={props.onChangeData}
                  value="P">
                </Radio>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-103"
                inline={true}
                width={3}>
                <div
                  id="CardOrderSetTemplateUX-div-143"
                  style={{width: "100%"}}>
                  {props.searchDoctorDetail}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardOrderSetTemplateUX-FormGroup-104"
              inline={true}
              style={{ ...(!props.showTemplateDetail && { display: "none"}) }}>
              <FormField
                id="CardOrderSetTemplateUX-FormField-108"
                inline={true}>
                <label
                  id="CardOrderSetTemplateUX-label-116"
                  style={{ fontWeight: "bold", color: "#2185d0" }}>
                  {props.languageUX === "en" ? "List of commands in the command set" : "รายการตำสั่งในชุดคำสั่ง"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardOrderSetTemplateUX-FormGroup-105"
              inline={true}
              style={{ display: "flex", alignItems: "flex-end", ...(!props.showTemplateDetail && { display: "none"}),  }}>
              <FormField
                id="CardOrderSetTemplateUX-FormField-106"
                inline={true}
                width={3}>
                <div
                  id="CardOrderSetTemplateUX-div-130"
                  style={{ width: "100%" }}>
                  
                  <div
                    id="CardOrderSetTemplateUX-div-132">
                    {props.languageUX === "en" ? "Command type" : "ประเภทคำสั่ง"}
                  </div>
                  <Dropdown
                    fluid={true}
                    id="CardOrderSetTemplateUX-Dropdown-134"
                    name="typeOrderDetail"
                    onChange={props.onChangeData}
                    options={props.typeOrderDetailOption}
                    selection={true}
                    value={props.typeOrderDetail}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardOrderSetTemplateUX-FormField-107"
                inline={true}
                width={10}>
                <div
                  id="CardOrderSetTemplateUX-div-131"
                  style={{ width: "100%" }}>
                  
                  <div
                    id="CardOrderSetTemplateUX-div-133">
                    {props.languageUX === "en" ? "Find commands" : "ค้นหาคำสั่ง"}
                  </div>
                  <div
                    id="CardOrderSetTemplateUX-div-145">
                    {props.searchOrderList}
                  </div>
                </div>
              </FormField>
              <FormField
                inline={true}
                style={{ marginBottom: "4px" }}
                width={2}>
                <div
                  style={{ width: "100%" }}>
                  
                  <div>
                    
                  </div>
                  <div>
                    {props.buttonSearch}
                  </div>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardOrderSetTemplateUX-FormGroup-136"
              style={{ ...(!props.showTemplateDetail && { display: "none"}) }}>
              <div
                id="CardOrderSetTemplateUX-div-137"
                style={{ width: "100%", }}>
                
                <div
                  id="CardOrderSetTemplateUX-div-144">
                  {props.orderDetailList}
                </div>
              </div>
            </FormGroup>
            <FormGroup
              id="CardOrderSetTemplateUX-FormGroup-159"
              style={{ ...(!props.showTemplateDetail && { display: "none"}) }}>
              <div
                id="CardOrderSetTemplateUX-div-160"
                style={{ display: "flex", justifyContent: "flex-end", width: "100%", ...(props.orderDetail?.id && { display: "none" }) }}>
                
                <div
                  id="CardOrderSetTemplateUX-div-170">
                  {props.buttonSaveTemplate}
                </div>
                <Button
                  color="red"
                  id="CardOrderSetTemplateUX-Button-162"
                  onClick={props.closeTemplate}
                  size="mini">
                  {props.languageUX === "en" ? "Cancel creation of command set" : "ยกเลิกการสร้างชุดคำสั่ง"}
                </Button>
              </div>
              <div
                id="CardOrderSetTemplateUX-div-173"
                style={{ display: "flex", justifyContent: "flex-end", width: "100%", ...(!props.orderDetail?.id && { display: "none" }) }}>
                
                <div
                  id="CardOrderSetTemplateUX-div-174">
                  {props.buttonEditTemplate}
                </div>
                <div
                  id="CardOrderSetTemplateUX-div-175">
                  {props.buttonDeleteTemplate}
                </div>
              </div>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default CardOrderSetTemplateUX

export const screenPropsDefault = {"cardSelectTemplate":"[CardSelectTemplate]","divisionChoices":{"0":{"key":1,"text":"a","value":1}},"dsbList":{"0":1,"1":2},"mode":"home","selectedChairs":"00023-1, 00024-2","zoneSelector":"[ZoneSelector]"}

/* Date Time : Tue Feb 03 2026 09:10:41 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width: \"100%\", height: \"95vh\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "size small --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"30%\", padding: \"15px\", borderRight: \"2px solid rgb(204, 204, 204)\" }"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "size small --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{flex: \"3 1 0%\", height: \"95vh\", overflow: \"auto\", padding: \"15px\", marginTop: \"60px\" }"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", height: \"40px\", }"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการชุดคำสั่ง",
          "valueEN": "List of command sets"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-label-44"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: \"15px\" }"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Form",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Form-87"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormGroup",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormGroup-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.showTemplateDetail && { display: \"none\"}) }"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 88,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-89"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "12"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormGroup",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormGroup-97"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.showTemplateDetail && { display: \"none\"}) }"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 97,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-98"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 97,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-99"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 97,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 97,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-101"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 97,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 97,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-103"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormGroup",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormGroup-104"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.showTemplateDetail && { display: \"none\"}) }"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormGroup",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormGroup-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"flex-end\", ...(!props.showTemplateDetail && { display: \"none\"}),  }"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-107"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทชุดคำสั่ง : "
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-label-109"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Radio",
      "parent": 99,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.orderDetail?.type === \"G\""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Radio-110"
        },
        "label": {
          "type": "value",
          "value": "ชุดคำสั่งกลาง",
          "valueEN": "Central command set"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "G"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Radio",
      "parent": 100,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.orderDetail?.type === \"D\""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Radio-111"
        },
        "label": {
          "type": "value",
          "value": "ชุดคำสั่งประจำแผนก",
          "valueEN": "Departmental Orders"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "D"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Radio",
      "parent": 102,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.orderDetail?.type === \"P\""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Radio-114"
        },
        "label": {
          "type": "value",
          "value": "ชุดคำสั่งแพทย์",
          "valueEN": "Medical order set"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "value",
          "value": "P"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "label",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการตำสั่งในชุดคำสั่ง",
          "valueEN": "List of commands in the command set"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-label-116"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", color: \"#2185d0\" }"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "Form",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Form-117"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormGroup",
      "parent": 117,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormGroup-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: \"15px\" }"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "FormField",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-119"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormField",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-120"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 119,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 121,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทชุดคำสั่ง",
          "valueEN": "Instruction set type"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-123"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาชุดคำสั่ง",
          "valueEN": "Find a set of instructions"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-125"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "Dropdown",
      "parent": 121,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Dropdown-127"
        },
        "name": {
          "type": "value",
          "value": "type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchData"
        },
        "options": {
          "type": "code",
          "value": "props.typeOrderOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchTemplate?.type"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-128"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Dropdown",
      "parent": 128,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.orderDetail?.type !== \"D\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Dropdown-129"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.orderDivisionOption"
        },
        "placeholder": {
          "type": "value",
          "value": "เลือกแผนก"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.orderDetail?.division"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 107,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทคำสั่ง",
          "valueEN": "Command type"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-132"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 131,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาคำสั่ง",
          "valueEN": "Find commands"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-133"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "Dropdown",
      "parent": 130,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Dropdown-134"
        },
        "name": {
          "type": "value",
          "value": "typeOrderDetail"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.typeOrderDetailOption"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.typeOrderDetail"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "FormGroup",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormGroup-136"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.showTemplateDetail && { display: \"none\"}) }"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-137"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", }"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addNewOrder"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-140"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "props.templateList"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-141"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchDoctorDetail"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-143"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 137,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderDetailList"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-144"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 131,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchOrderList"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-145"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormGroup",
      "parent": 117,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormGroup-146"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-148"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 147,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 149,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-150"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 148,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-151"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "physician"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-152"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "Dropdown",
      "parent": 149,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.searchTemplate?.type == \"P\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Dropdown-153"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchData"
        },
        "options": {
          "type": "code",
          "value": "props.templateDivisionOption"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchTemplate?.division"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 146,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormField-155"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginTop: \"18px\" }"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormGroup",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-FormGroup-159"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.showTemplateDetail && { display: \"none\"}) }"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-160"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", width: \"100%\", ...(props.orderDetail?.id && { display: \"none\" }) }"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 162,
      "name": "Button",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการสร้างชุดคำสั่ง",
          "valueEN": "Cancel creation of command set"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Button-162"
        },
        "onClick": {
          "type": "code",
          "value": "props.closeTemplate"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-163"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"200px\" }"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-164"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-165"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\", margin: \"0px 5px\" }"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ":"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-166"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "label",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อชุดคำสั่ง",
          "valueEN": "Command set name"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-label-167"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "Input",
      "parent": 164,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Input-168"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.orderDetail?.name || \"\""
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 151,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchDoctorTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-169"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "div",
      "parent": 160,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSaveTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-170"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearchTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-171"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "Input",
      "parent": 122,
      "props": {
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-Input-172"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchData"
        },
        "value": {
          "type": "code",
          "value": "props.searchTemplate?.name"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-173"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", width: \"100%\", ...(!props.orderDetail?.id && { display: \"none\" }) }"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEditTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-174"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonDeleteTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardOrderSetTemplateUX-div-175"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 176,
      "name": "FormField",
      "parent": 105,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"4px\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 176,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "div",
      "parent": 178,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "div",
      "parent": 178,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        }
      },
      "seq": 180,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardOrderSetTemplateUX",
  "project": "cudent2",
  "screenPropsDefault": {
    "cardSelectTemplate": "[CardSelectTemplate]",
    "divisionChoices": {
      "0": {
        "key": 1,
        "text": "a",
        "value": 1
      }
    },
    "dsbList": {
      "0": 1,
      "1": 2
    },
    "mode": "home",
    "selectedChairs": "00023-1, 00024-2",
    "zoneSelector": "[ZoneSelector]"
  },
  "width": 85
}

*********************************************************************************** */
